/**
 * Terms & Policies content labels
 */

import svTerms from '../locales/sv/terms.json';
import enTerms from '../locales/en/terms.json';
import { getLanguage, type Language } from '@/utils/languageUtils';

const getTermsLocale = (lang?: Language) => {
  const currentLang = lang || getLanguage();
  return currentLang === 'en' ? enTerms : svTerms;
};

export const termsLabels = (lang?: Language) => getTermsLocale(lang);
